module.exports = "/_next/static/images/Pictogram_watch-a998b8cecda09c6dc39b410c9eef9607.svg";